import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CalendarOptions, EventApi, FullCalendarComponent } from '@fullcalendar/angular';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/service/auth/auth.service';
import { CourtService } from 'src/app/service/common/court.service';
import { HomeService } from 'src/app/service/common/home.service';
import { UserType } from 'src/app/service/common/interface';
import { MessageService } from 'src/app/service/common/message.service';
import { SupportService } from 'src/app/service/common/support.service';
import { BarristerService } from 'src/app/service/pages/barrister.service';

@Component({
  selector: 'app-barrister-diary',
  templateUrl: './barrister-diary.component.html',
  styleUrls: ['./barrister-diary.component.css']
})
export class BarristerDiaryComponent implements OnInit {

  private _subs : Subscription = new Subscription();
  dateEvent: any[] = [];
  diaryFilter : {
    entryType : string,
    caseTypeId : string,
    clientTypeId : string,
    courtId : string,
    fundingTypeId : string,
    courtBundleReceived : string,
    attendanceNoteReceived : string,
    paymentReceived : string,
    barristerId : string,
    selectedId : string[]
  }
  caseTypes : any;
  courts : any;
  fundingTypes : any;
  barristers : any;
  userType : UserType = null;
  calendarReady = false;
  filtersExpanded = false;

  calendarOptions: CalendarOptions;
  @ViewChild('calendar') calendarComponent: FullCalendarComponent;


  constructor(
    public datepipe: DatePipe,
    private router : Router,
    private auth : AuthService,
    private supportService : SupportService,
    private barristerService : BarristerService,
    private courtService : CourtService,
    private homeService : HomeService
  ) {

    this.diaryFilter = {
      entryType : "all",
      caseTypeId : "all",
      clientTypeId : "all",
      courtId : "all",
      fundingTypeId : "all",
      courtBundleReceived : "all",
      attendanceNoteReceived : "all",
      paymentReceived : "all",
      barristerId : "selected",
      selectedId : []
    }

    this._subs.add(
      this.supportService.getNames('caseTypes').subscribe(res => {
        this.caseTypes = res.data;
      })
    )
    this._subs.add(
      this.supportService.getNames('fundingTypes').subscribe(res => {
        this.fundingTypes = res.data;
      })
    )
    this._subs.add(
      this.barristerService.getBarristers('Solicitor', '1').subscribe(res =>{
        this.barristers = res.data;
      })
    )
    this._subs.add(
      this.courtService.getCourts('1').subscribe(res =>{
        this.courts = res.data;
      })
    )

    if(this.auth.getUserType()){
      this.auth.getUserType().subscribe(res=>{
        this.userType = res;
        if(this.userType.userTypeId){
          if(this.userType.userTypeId == 2){
            this.setBarristerId(this.userType.barristerId);
          }else{
            this.diaryFilter.barristerId = 'all';
          }
          // Load events after barristerId is set
          if (this.calendarReady) {
            this.loadEvents();
          }
        }
      });
    }


  }

  handleEvents(event: EventApi | any): void {
    if (this.calendarComponent) {
      this.loadEvents();
    }
  }


  ngOnInit(): void {

  }

  ngAfterViewInit(){
    this.calendarReady = true;
    if (this.userType && this.userType.userTypeId) {
      this.loadEvents();
    }
  }

  setCalenderDate($event){
    this.calendarComponent.getApi().gotoDate( $event.target.value);
    this.calendarComponent.getApi().changeView('dayGridDay');
    let startDate = this.calendarComponent.getApi().view.activeStart;
    let endDate = this.calendarComponent.getApi().view.activeEnd;

  }

  clearFilters(){
    // Preserve barristerId and selectedId for barrister diary
    const currentBarristerId = this.diaryFilter.barristerId;
    const currentSelectedId = this.diaryFilter.selectedId;
    this.diaryFilter = {
      entryType : "all",
      caseTypeId : "all",
      clientTypeId : "all",
      courtId : "all",
      fundingTypeId : "all",
      courtBundleReceived : "all",
      attendanceNoteReceived : "all",
      paymentReceived : "all",
      barristerId : currentBarristerId,
      selectedId : currentSelectedId
    }
    this.loadEvents();
  }

  async setBarristerId(id){
    if(id){
      this.diaryFilter.barristerId = 'selected';
      this.diaryFilter.selectedId = [id];
    }
  }

  updateBarristerId(id){
    this.setBarristerId(id);
    this.loadEvents();
  }

  toggleFilters(){
    this.filtersExpanded = !this.filtersExpanded;
  }

  loadEvents(){
    // debugger;
    if (this.calendarComponent) {

      let startDate = this.datepipe.transform(this.calendarComponent.getApi().view.activeStart, 'yyyy-MM-dd');
      let endDate = this.datepipe.transform(this.calendarComponent.getApi().view.activeEnd, 'yyyy-MM-dd');


      let diaryArray = this.convertToArray();

      diaryArray.push(startDate);
      diaryArray.push(endDate);

      // console.log(diaryArray);

      this._subs.add(
        this.homeService.getDiaryCounts(diaryArray).subscribe(res => {
          console.log('BARRISTER DIARY - User Data:', this.userType);
          console.log('BARRISTER DIARY - API Data:', res.data);
          let allEvents = res.data || [];
          // Filter events to show only barrister's own events (holidays where event.id == barristerId, cases are already filtered by API)
          allEvents = allEvents.filter(event => {
            const isHoliday = event.modelName == 'holiday' || event.extendedProps?.modelName == 'holiday';
            return isHoliday ? (event.id == this.userType.barristerId.toString()) : true;
          });
          console.log('BARRISTER DIARY - Filtered Events Count:', allEvents.length);
          this.dateEvent = allEvents;
          this.calendarOptions = {
            datesSet: this.handleEvents.bind(this),
            initialView: 'dayGridMonth',
            headerToolbar :{
              left : 'prev,next today',
              center : 'title',
              right : 'dayGridMonth,dayGridWeek,dayGridDay'
            },
            weekends : true,
            eventClick: this.handleEventClick.bind(this),
            nextDayThreshold: "00:00:00",
            events: this.dateEvent
          }
        })
      )

    }


  }

  convertToArray(){
    let temp = [];
    temp.push(this.diaryFilter.entryType);
    temp.push(this.diaryFilter.caseTypeId);
    temp.push(this.diaryFilter.clientTypeId);
    temp.push(this.diaryFilter.courtId);
    temp.push(this.diaryFilter.fundingTypeId);
    temp.push(this.diaryFilter.courtBundleReceived);
    temp.push(this.diaryFilter.attendanceNoteReceived);
    temp.push(this.diaryFilter.paymentReceived);
    temp.push(this.diaryFilter.barristerId);
    temp.push(this.diaryFilter.selectedId);
    return temp;
  }

  handleEventClick(args){

    if(args.event.extendedProps.modelName == 'holiday'){
      this.router.navigateByUrl("pages/barristers/view/"+args.event.id+"/holidays");
    }else{
      this.router.navigateByUrl("/pages/cases/view/"+args.event.id);
    }

  }

}
